<template>
  <section id="SectionEquipment">
    <Wrap class="lg">
      <h2 class="headline">
        {{ $t('headline') }}
      </h2>
      <SubSectionInverters />
      <SubSectionModules />
    </Wrap>
  </section>
</template>

<script>
import SubSectionInverters from './SubSectionInverters'
import SubSectionModules from './SubSectionModules'

export default {
  components: { SubSectionModules, SubSectionInverters },
}
</script>

<style lang="scss">
#SectionEquipment {
  background-color: $white;
  color: $white;
  padding: 3rem 0;
  @include md {
    background-image: url('../../../../../assets/ellipses-full.png');
    background-position: top left;
    padding: 6rem;
  }

  .headline {
    color: $main;
    padding-bottom: 5rem;
  }
}

</style>

<i18n>
{
  "lt": {
    "headline": "Saulės elektrinių įranga",
    "subHeadlineInverters": "Inverteriai (įtampos keitikliai)",
    "text": "Saulės modulių kaina sudaro apie 40-50 % saulės elektrinės kainos, todėl į jų kokybę kreipiamas didžiausias dėmesys. Siūlome saulės modulius iš Tier1 sąrašo, kuri sudaro „Bloomberg New Energy Finance“.",
    "linkDescription": "Naujausias Tier1 gamintojų sąrašas: ",
    "linkText": "čia"
  }
}
</i18n>
